<div class="active-filter-banner" *transloco="let t" @fadeAnimation>
  <div class="text-side">
    <i class="material-symbols-rounded">info</i>
    <span>
      {{ t('shared/activeFilters') }}.
      <span class="reset-link" (click)="onResetClick()">{{ t('shared/reset') }}</span>
    </span>
  </div>
</div>
